import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-edit-banner',
  templateUrl: './edit-banner.component.html',
  styleUrls: ['./edit-banner.component.scss']
})
export class EditBannerComponent implements OnInit, AfterViewInit {
  @Input() bannerInfo: any;
  fileImg641: any;
  wrongSize: any;
  bannerForm: FormGroup;
  fileImg642: any;
  fileImg643: any;
  wrongSize2: any;
  wrongSize3: any;
  maxLength = 350;
  indexSelected: number[] = [];
  bannerPromoImagesDeleted: any = [];

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.bannerForm = this.fb.group({
      title: [(this.bannerInfo ? this.bannerInfo.title : null), Validators.required],
      urlModal: [(this.bannerInfo ? this.bannerInfo.urlModal : null)],
      dateFrom: [(this.bannerInfo.dateFrom ? moment(this.bannerInfo.dateFrom).format() : null)],
      dateTo: [(this.bannerInfo.dateTo ? moment(this.bannerInfo.dateTo).format() : null)],
      img643: [''],
      img643Upload: [false],
      img3: [(this.bannerInfo ? this.bannerInfo.img3 : null)],
      isDefault: [(this.bannerInfo ? this.bannerInfo.isDefault : null)],
    });

    this.bannerInfo.bannerPromoImages.forEach(item => {
      item.img641 = '';
      item.img642 = '';
      item.fileImg641 = (item ? item.img1 : null);
      item.fileImg642 = (item ? item.img2 : null);
      item.img641Upload = false;
      item.img642Upload = false;
      item.wrongSize1 = '';
      item.wrongSize2 = '';
    });
    this.fileImg643 = (this.bannerInfo ? this.bannerInfo.img3 : null)
    this.bannerInfo.bannerPromoImages = this.bannerInfo.bannerPromoImages.sort((a, b) => a.orderImgId - b.orderImgId);
  }

  ngAfterViewInit(): void { }

  changeDefault(val: string) {
    this.bannerForm.value.isDefault = (val == 'yes' ? true : false)
  }

  isValidImages() {
    let rpta = true;
    this.bannerInfo.bannerPromoImages.forEach(item => {
      if (item.fileImg641 == '' || item.fileImg642 == '' || !item.urlBanner) {
        rpta = false;
        return rpta;
      }
    });
    return rpta;
  }
  sendData() {
    if (!this.isValidImages()) {
      Swal.fire({
        title: 'Oops...',
        text: 'Debes ingresar ambas las imágenes del Banner',
        icon: 'error',
        backdrop: false,
        confirmButtonText: 'Aceptar',
      });
      return false;
    }

    let pass = true
    if (([null, ''].includes(this.bannerForm.value.dateFrom) == true && [null, ''].includes(this.bannerForm.value.dateTo) == false) || ([null, ''].includes(this.bannerForm.value.dateFrom) == false && [null, ''].includes(this.bannerForm.value.dateTo) == true)) {
      pass = false
      Swal.fire({
        title: 'Oops...',
        text: 'Debes ingresar ambas fechas o ninguna',
        icon: 'error',
        backdrop: false,
        confirmButtonText: 'Aceptar',
      });
    } else if ([null, ''].includes(this.bannerForm.value.dateFrom) == false && [null, ''].includes(this.bannerForm.value.dateTo) == false) {
      if (this.convertDate(this.bannerForm.value.dateTo) < this.convertDate(this.bannerForm.value.dateFrom)) {
        pass = false
        Swal.fire({
          title: 'Oops...',
          text: ' La fecha de fin debe ser mayor a la fecha de inicio',
          icon: 'error',
          backdrop: false,
          confirmButtonText: 'Aceptar',
        });
      }
    }
    if (pass) {
      const dataToSend = {
        ...this.bannerForm.value,
        id: this.bannerInfo.id,
      };

      dataToSend.dateFrom = dataToSend.dateFrom ? moment(dataToSend.dateFrom).format("YYYY-MM-DD") : '';
      dataToSend.dateTo = dataToSend.dateFrom ? moment(dataToSend.dateTo).format("YYYY-MM-DD") : '';

      let bannerPromoImageUpdate = [];
      this.bannerInfo.bannerPromoImages.filter(x => x.active = 0);
      this.bannerPromoImagesDeleted.filter(x => x.active = 1);
      this.bannerInfo.bannerPromoImages = this.bannerInfo.bannerPromoImages.concat(this.bannerPromoImagesDeleted);

      this.bannerInfo.bannerPromoImages.forEach(item => {
        let bannerPromoImageUpdate_ = {
          id: item.imgId ? item.imgId : 0,
          orderId: item.orderImgId,
          img1: item.img1,
          img641: item.img641,
          img641Upload: item.img641Upload,
          img2: item.img2,
          img642: item.img642,
          img642Upload: item.img642Upload,
          urlBanner: item.urlBanner,
          active: item.active

        }
        bannerPromoImageUpdate.push(bannerPromoImageUpdate_);
      });
      dataToSend.bannerPromoImageUpdate = bannerPromoImageUpdate;
      this.activeModal.close(dataToSend);
    }
  }

  convertDate(date?: any): any {
    return date ? this.takeOutHMS(new Date(date)) : this.takeOutHMS(new Date());
  }

  takeOutHMS(fec: Date) {
    fec.setHours(0);
    fec.setMinutes(0);
    fec.setSeconds(0);
    fec.setMilliseconds(0)
    return fec;
  }

  getDateBanner(date): any {
    if (date) {
      let espace = ' '
      let arrayDate = date.split(espace)[0]
      return arrayDate;

    }
  }

  getBase64(event, img, img64, tipo): void {
    if (!event.target.files[0]) { return; }
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        switch (tipo) {
          case 3:
            if (image.width == 600 && image.height == 700) {
              this.wrongSize3 = null;
              this.fileImg643 = image.src;
              this.bannerForm.get(img64).setValue(this.fileImg643.split(',')[1]);
              this.bannerForm.get(img).setValue((event.target.files[0]).name);
              this.bannerForm.get('img643Upload').setValue(true);
            } else {
              this.wrongSize3 = 'Resolución de imagen no permitida (requerida: 600px x 700px)';
              return false;
            }
            break;
          case 2:
            if (image.width == 822 && image.height == 272) {
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].wrongSize2 = null;
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].fileImg642 = image.src;
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].img642 = image.src.split(',')[1];
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].img2 = (event.target.files[0]).name;
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].img642Upload = true;
            } else {
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].wrongSize2 = 'Resolución de imagen no permitida (requerida: 822px x 272px)';
              return false;
            }
            break;
          default:
            if (image.width == 1440 && image.height == 120) {
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].wrongSize1 = null;
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].fileImg641 = image.src;
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].img641 = image.src.split(',')[1];
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].img1 = (event.target.files[0]).name;
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].img641Upload = true;
            } else {
              this.bannerInfo.bannerPromoImages[this.indexSelected[this.indexSelected.length - 2]].wrongSize1 = 'Resolución de imagen no permitida (requerida: 1440px x 120px)';
              return false;
            }
            this.indexSelected = [];
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  createBannerPromo() {
    this.bannerInfo.bannerPromoImages.push({
      img1: '',
      img2: '',
      img641: '',
      img642: '',
      fileImg641: '',
      fileImg642: '',
      imgId: '',
      orderImgId: this.bannerInfo.bannerPromoImages.length + 1,
      urlBanner: '',
      wrongSize1: '',
      wrongSize2: '',
      img641Upload: false,
      img642Upload: false
    });
  }

  deleteBannerPromo(i: number): any {
    if (this.bannerInfo.bannerPromoImages.length == 1) {
      Swal.fire({
        title: 'Oops...',
        text: 'Debes tener al menos una imagen de Banner',
        icon: 'error',
        backdrop: false,
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    this.bannerPromoImagesDeleted.push(this.bannerInfo.bannerPromoImages[i]);
    this.bannerInfo.bannerPromoImages.splice(i, 1);
  }

  moveBannerPromo(i: number, y: number) {
    if (y == 1) { // Up
      if (i == 0) { return false };
      this.bannerInfo.bannerPromoImages[i].orderImgId = this.bannerInfo.bannerPromoImages[i].orderImgId - 1;
      this.bannerInfo.bannerPromoImages[i - 1].orderImgId = this.bannerInfo.bannerPromoImages[i - 1].orderImgId + 1;
    } else if (y == 2) { // Down
      if (i == this.bannerInfo.bannerPromoImages.length - 1) { return false };
      this.bannerInfo.bannerPromoImages[i].orderImgId = this.bannerInfo.bannerPromoImages[i].orderImgId + 1;
      this.bannerInfo.bannerPromoImages[i + 1].orderImgId = this.bannerInfo.bannerPromoImages[i + 1].orderImgId - 1;
    }

    this.bannerInfo.bannerPromoImages = this.bannerInfo.bannerPromoImages.sort((a, b) => a.orderImgId - b.orderImgId);
  }

  lastIndexSelected(i: number) {
    this.indexSelected.push(i);
  }
}
